var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContainer',[_c('PageTitle',[_vm._v(" "+_vm._s(_vm.trans('PAGE_TITLE:AccountBlocked'))+" ")]),(_vm.userData.isBanned)?_c('t-card',{staticClass:"w-full lg:w-420"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }